import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setCurrentTeam } from '../store/reducers/user'
import { useNavigate } from 'react-router-dom'
import { logout } from '../store/reducers/user'

export function TeamSelector() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const user = useSelector(state => state.user)
    const { teams, currentTeam, _id } = user
    const [isOpen, setIsOpen] = useState(false)

    if (!_id) return null

    return <>
        {isOpen && <div className='screen' onClick={() => setIsOpen(false)} />}
        <div className='team-selector' style={{ zIndex: 1000 }}>
            <div className={`team-pick noselect ${isOpen ? 'open-border' : 'closed-border'}`} style={{ padding: '3px 10px' }} onClick={() => setIsOpen(!isOpen)}>
                <img src={currentTeam?.channelImage || user.img} />
                <p>{currentTeam?.channelName || user.name}</p>
                <span className="material-symbols-outlined">{isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</span>
            </div>
            {(isOpen) && <div className='teams-menu'>
                {teams.map(team => <div key={team._id} className='team-pick' onClick={() => { dispatch(setCurrentTeam(team)); navigate('/team'); setIsOpen(false) }}>
                    <img src={team.channelImage} alt={team.channelName} />
                    <p>{team.channelName}</p>
                </div>)}
                <div className='line back-main7' />
                <div className='team-pick' onClick={() => { navigate('/new-team'); setIsOpen(false) }}>
                    <span className="material-symbols-outlined">add</span>
                    <p>צוות חדש</p>
                </div>
                <div className='team-pick' onClick={() => { navigate('/profile'); setIsOpen(false) }}>
                    <span className="material-symbols-outlined">account_circle</span>
                    <p>פרופיל</p>
                </div>
                <div className='team-pick' onClick={() => { dispatch(logout()); setIsOpen(false) }}>
                    <span className="material-symbols-outlined">logout</span>
                    <p>התנתק</p>
                </div>
            </div>}
        </div>
    </>
}